document.addEventListener('DOMContentLoaded', function () {
    var popup = document.querySelector('[data-personalization-popup]');
    if (!popup) {
        return;
    }

    var canvas = popup.querySelector('[data-personalization-canvas]');
    var input = popup.querySelector('[data-personalization-input]');
    var counter = popup.querySelector('[data-personalization-counter]');
    var applyBtn = popup.querySelector('[data-personalization-apply]');
    var clearBtn = popup.querySelector('[data-personalization-clear]');
    var maxLength = 2;
    var ctx = canvas.getContext('2d');
    var baseImage = new Image();
    baseImage.crossOrigin = 'anonymous';
    var imageLoaded = false;
    var isApplied = false;
    var showDefaultOnEmpty = true;

    var config = {
        textX: parseFloat(popup.dataset.textX) || 50,
        textY: parseFloat(popup.dataset.textY) || 50,
        align: 'center',
        color: popup.dataset.color || '#000000',
        fontSize: parseInt(popup.dataset.fontSize, 10) || 64
    };

    function formatValue(raw) {
        var letters = raw.replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2);
        return letters;
    }

    var defaultInitials = formatValue(popup.dataset.defaultInitials || 'RB');

    function displayValue(letters) {
        if (!letters) {
            return '';
        }
        return letters.split('').join('.') + '.';
    }

    function drawGlyphs(context, letters) {
        if (!letters) {
            return;
        }
        var x = context.canvas.width * (config.textX / 100);
        var y = context.canvas.height * (config.textY / 100);
        context.save();
        context.font = config.fontSize + "px 'PZFont01', Arial, sans-serif";
        context.fillStyle = config.color;
        context.textBaseline = 'middle';

        var text = displayValue(letters);
        context.lineJoin = 'round';
        var letterLineWidth = config.fontSize * 0.02;
        var dotLineWidth = config.fontSize * 0.008;
        context.strokeStyle = config.color;

        var totalWidth = context.measureText(text).width;
        var cursor = x;
        if (config.align === 'center') {
            cursor = x - totalWidth / 2;
        } else if (config.align === 'right') {
            cursor = x - totalWidth;
        }
        context.textAlign = 'left';
        text.split('').forEach(function (char) {
            context.lineWidth = char === '.' ? dotLineWidth : letterLineWidth;
            context.strokeText(char, cursor, y);
            context.fillText(char, cursor, y);
            cursor += context.measureText(char).width;
        });
        context.restore();
    }

    function render() {
        if (!imageLoaded) {
            return;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(baseImage, 0, 0, canvas.width, canvas.height);
        drawGlyphs(ctx, formatValue(input.value) || (showDefaultOnEmpty ? defaultInitials : ''));
    }

    baseImage.onload = function () {
        canvas.width = baseImage.naturalWidth;
        canvas.height = baseImage.naturalHeight;
        imageLoaded = true;
        render();
    };
    baseImage.src = popup.dataset.image;

    if (document.fonts && document.fonts.load) {
        document.fonts.load(config.fontSize + "px 'PZFont01'")
            .then(render)
            .catch(function () {});
        document.fonts.ready.then(render);
    }

    function updateApplyState() {
        var formatted = formatValue(input.value);
        applyBtn.disabled = formatted.length === 1 || (formatted.length === 0 && !showDefaultOnEmpty);
    }

    input.addEventListener('input', function () {
        var formatted = formatValue(input.value);
        if (input.value !== formatted) {
            input.value = formatted;
        }
        updateApplyState();
        clearBtn.disabled = formatted.length === 0 && !isApplied;
        if (counter) {
            counter.textContent = formatted.length + '/' + maxLength;
        }
        render();
    });

    function setFormFields(letters) {
        var forms = document.querySelectorAll('product-form form[action$="/cart/add"]');
        forms.forEach(function (form) {
            var propertyField = form.querySelector('[data-personalization-property]');
            var flagField = form.querySelector('[data-personalization-flag]');
            var fileField = form.querySelector('[data-personalization-file]');
            if (!propertyField || !flagField) {
                return;
            }
            if (letters) {
                propertyField.value = displayValue(letters);
                propertyField.disabled = false;
                flagField.disabled = false;
            } else {
                propertyField.value = '';
                propertyField.disabled = true;
                flagField.disabled = true;
                if (fileField) {
                    fileField.value = '';
                    fileField.disabled = true;
                }
            }
        });

        var trigger = document.querySelector('[data-personalization-trigger]');
        var triggerText = document.querySelector('[data-personalization-trigger-text]');
        if (trigger && triggerText) {
            triggerText.textContent = letters
                ? trigger.dataset.label + ': ' + displayValue(letters)
                : trigger.dataset.label;
        }
    }

    function closePopup() {
        popup.classList.remove('open');
        document.querySelector('body').classList.remove('disable-scroll');
        var wrapper = document.querySelector('body .wrapper');
        if (wrapper) {
            wrapper.classList.remove('disable-scroll');
        }
        var productPageInfo = document.querySelector('.product-page_info');
        if (productPageInfo) {
            productPageInfo.removeAttribute('style');
        }
    }

    function attachPreviewImage(callback) {
        canvas.toBlob(function (blob) {
            if (blob) {
                var file = new File([blob], 'personalization-preview.png', { type: 'image/png' });
                document.querySelectorAll('product-form form[action$="/cart/add"]').forEach(function (form) {
                    var fileField = form.querySelector('[data-personalization-file]');
                    if (!fileField) {
                        return;
                    }
                    var dataTransfer = new DataTransfer();
                    dataTransfer.items.add(file);
                    fileField.files = dataTransfer.files;
                    fileField.disabled = false;
                });
            }
            callback();
        }, 'image/png');
    }

    applyBtn.addEventListener('click', function () {
        var letters = formatValue(input.value);
        if (letters.length === 1) {
            return;
        }
        if (letters.length === 0 && !showDefaultOnEmpty) {
            return;
        }

        var finalLetters = letters.length === maxLength ? letters : defaultInitials;
        setFormFields(finalLetters);
        isApplied = true;
        clearBtn.disabled = false;
        attachPreviewImage(closePopup);
    });

    clearBtn.addEventListener('click', function () {
        input.value = '';
        isApplied = false;
        showDefaultOnEmpty = false;
        updateApplyState();
        clearBtn.disabled = true;
        if (counter) {
            counter.textContent = '0/' + maxLength;
        }
        setFormFields('');
        render();
    });

    var trigger = document.querySelector('[data-personalization-trigger]');
    if (trigger) {
        trigger.addEventListener('click', function () {
            showDefaultOnEmpty = true;
            updateApplyState();
            render();
        });
    }

    document.querySelectorAll('product-form form[action$="/cart/add"]').forEach(function (form) {
        form.addEventListener('submit', function () {
            var flagField = form.querySelector('[data-personalization-flag]');
            if (flagField && !flagField.disabled) {
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: { _has_personalization: 'true' } })
                }).catch(function (error) {
                    console.error(error);
                });
            }
        });
    });
});